"use client"

import { useEffect, useRef, useState } from "react"
import { getCurrentUser } from "@/lib/auth"
import { getCurrentLocation } from "@/lib/geolocation"

export function GlobalLocation() {
  const [userId, setUserId] = useState<number | null>(null)
  const lastErrorAt = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === "undefined") return

    const syncUser = () => {
      const user = getCurrentUser()
      setUserId(user?.id ?? null)
    }

    syncUser()

    const onStorage = (event: StorageEvent) => {
      if (event.key === "currentUser") {
        syncUser()
      }
    }

    window.addEventListener("storage", onStorage)
    return () => window.removeEventListener("storage", onStorage)
  }, [])

  useEffect(() => {
    if (!userId) return

    let active = true

    const updateLocation = async () => {
      if (!active) return
      if (lastErrorAt.current && Date.now() - lastErrorAt.current < 30000) return

      try {
        const coords = await getCurrentLocation()
        if (!active) return
        await fetch("/api/location/update", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId,
            latitude: coords.latitude,
            longitude: coords.longitude,
            accuracy: (coords as any).accuracy,
          }),
        })
      } catch (err) {
        lastErrorAt.current = Date.now()
        console.error("[v0] Failed to update location (global):", err)
      }
    }

    updateLocation()
    const interval = window.setInterval(updateLocation, 30000)

    return () => {
      active = false
      window.clearInterval(interval)
    }
  }, [userId])

  return null
}
